// src/components/Services.jsx

import React from 'react';

const FinancialProjections = () => {
  return (
    <div>

<h2 className="text-4xl font-bold text-black mb-5">
Detailed Financial Projections and<span className="text-[#680099] ml-2 font-bold">Analysis</span>
</h2>
      

      {/* Container for the two boxes */}
      <div style={boxesContainerStyle}>
        {/* Left box */}
        <div style={leftBoxStyle}>
          <div style={boxHeadingStyle}>Metric</div>
          <p style={boxContentStyle}> Agent Growth</p>
          <p style={leftboxContentStyle}> Active Agents</p>
          <p style={leftboxContentStyle}> Annual Revenue</p>
          <p style={leftboxContentStyle}> Net profit</p>

        </div>

        <div style={leftBoxStyle1}>
          <div style={boxHeadingStyle}>Year 1 (2026)</div>
          <p style={boxContentStyle}> 200 Agents</p>
          <p style={leftboxContentStyle}> 80/Month </p>
          <p style={leftboxContentStyle}> ₹ 3.84 Crore</p>
          <p style={leftboxContentStyle}> ₹ 65 lakhs</p>
        </div>

        {/* middle box */}
        <div style={leftBoxStyle1}>
          <div style={boxHeadingStyle}>Year 2 (2027)</div>
          <p style={boxContentStyle}> 300 Agents</p>
          <p style={leftboxContentStyle}> 120/Month </p>
          <p style={leftboxContentStyle}> ₹ 5.76 Crore</p>
          <p style={leftboxContentStyle}> ₹ 1.04 Crore</p>
        </div>

        {/* Right box */}
        <div style={leftBoxStyle1}>
          <div style={boxHeadingStyle}>Year 3 (2028)</div>
          <p style={boxContentStyle}> 450 Agents</p>
          <p style={leftboxContentStyle}> 180/Month </p>
          <p style={leftboxContentStyle}> ₹ 8.64 Crore</p>
          <p style={leftboxContentStyle}> ₹ 1.72 Crore</p>
        </div>


        <div style={rightBoxStyle}>
          <div style={boxHeadingStyle}>Assumptions</div>
          <p style={boxContentStyle}>Onbaording 10-15 Agents/ Month Intially, Increasing With Platform Credibililty. </p>
          <p style={rightboxContentStyle}>40-50% Of Onboarded Agents Actively Engage, Typical B2B Travel</p>
          <p style={rightboxContentStyle}>Growth Driven By Agent Acquisition And Forex Integration.</p>
          <p style={rightboxContentStyle}>Profit Margin Improves As The Platform Scales.</p>

        </div>
      </div>

      <p style={{fontSize: '20px'}}> <strong> Break-Even Analysis: </strong> Expected by the <strong> end of Year 2,</strong> considering revenue growth and operations efficiencies. </p>



      
    </div>
  );
};



const boxesContainerStyle = {
  display: 'flex',  // Align items side by side
  gap: '20px',  // Space between the boxes
  marginTop: '19px',  // Optional: space between heading and boxes

};

const leftBoxStyle = {
  flex: 1,  // Takes up available space, but narrower due to specific width
  maxWidth: '20%',  // Adjust width to make it narrower
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',

};

const leftBoxStyle1 = {
  flex: 1,  // Takes up available space, but narrower due to specific width
  maxWidth: '14%',  // Adjust width to make it narrower
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',
};


const rightBoxStyle = {
  flex: 1,  // Takes up available space
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',
  maxWidth: '60%',  // Adjust width to make it narrower

};

const boxHeadingStyle = {
  backgroundColor: '#321e5d',  // Background color for the heading
  color: 'white',
  padding: '10px',
  borderRadius: '30px 30px 0px 0px',   
  fontSize: '20px',
  fontWeight: 'bold',  
  textAlign: 'center',

  
};

const boxContentStyle = {
  
  textAlign: 'center',
  marginTop: '20px',
  fontSize: '18px'
};


const leftboxContentStyle = {
  
  textAlign: 'center',
  marginTop: '20px',
  fontSize: '18px',
  marginTop: '55px'
};

const rightboxContentStyle = {
  
  textAlign: 'center',
  marginTop: '20px',
  marginBottom: '30px',
  fontSize: '18px',
};


export default FinancialProjections;
